"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconClockStroke = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconClockStroke = function SvgIconClockStroke(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("mask", {
    id: "si_clock__a",
    maskUnits: "userSpaceOnUse",
    x: -0.5,
    y: -0.5,
    width: 13,
    height: 13,
    fill: "#000"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M-.5-.5h13v13h-13z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 6C.5 2.967 2.967.5 6 .5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5A5.506 5.506 0 01.5 6zm.852 0A4.654 4.654 0 006 10.648 4.654 4.654 0 0010.648 6 4.653 4.653 0 006 1.352 4.654 4.654 0 001.352 6zm5.074-.179l1.534 1.15a.425.425 0 11-.512.682L5.744 6.375a.425.425 0 01-.17-.34V3.477a.426.426 0 11.852 0v2.343z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 6C.5 2.967 2.967.5 6 .5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5A5.506 5.506 0 01.5 6zm.852 0A4.654 4.654 0 006 10.648 4.654 4.654 0 0010.648 6 4.653 4.653 0 006 1.352 4.654 4.654 0 001.352 6zm5.074-.179l1.534 1.15a.425.425 0 11-.512.682L5.744 6.375a.425.425 0 01-.17-.34V3.477a.426.426 0 11.852 0v2.343z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.96 6.972l-.09.12.09-.12zm-1.534-1.15h-.15v.074l.06.045.09-.12zm1.619 1.746l-.12-.09.12.09zm-.597.085l.09-.12-.09.12zM5.744 6.375l.09-.12-.09.12zM6 .35A5.656 5.656 0 00.35 6h.3C.65 3.05 3.05.65 6 .65v-.3zM11.65 6A5.656 5.656 0 006 .35v.3c2.95 0 5.35 2.4 5.35 5.35h.3zM6 11.65A5.656 5.656 0 0011.65 6h-.3c0 2.95-2.4 5.35-5.35 5.35v.3zM.35 6A5.656 5.656 0 006 11.65v-.3C3.05 11.35.65 8.95.65 6h-.3zM6 10.498A4.504 4.504 0 011.502 6h-.3A4.804 4.804 0 006 10.798v-.3zM10.498 6A4.504 4.504 0 016 10.498v.3A4.804 4.804 0 0010.798 6h-.3zM6 1.502A4.503 4.503 0 0110.498 6h.3A4.803 4.803 0 006 1.202v.3zM1.502 6A4.504 4.504 0 016 1.502v-.3A4.804 4.804 0 001.202 6h.3zm6.548.852l-1.534-1.15-.18.24 1.534 1.15.18-.24zm.115.806a.575.575 0 00-.115-.807l-.18.24a.275.275 0 01.055.386l.24.18zm-.461.23a.573.573 0 00.461-.231l-.24-.179a.273.273 0 01-.221.11v.3zm-.346-.115a.573.573 0 00.346.115v-.3a.274.274 0 01-.166-.055l-.18.24zM5.654 6.495l1.704 1.278.18-.24-1.704-1.278-.18.24zm-.23-.46c0 .18.085.352.23.46l.18-.24a.275.275 0 01-.11-.22h-.3zm0-2.557v2.556h.3V3.478h-.3zM6 2.902a.576.576 0 00-.576.576h.3c0-.153.123-.276.276-.276v-.3zm.576.576A.576.576 0 006 2.902v.3c.153 0 .276.123.276.276h.3zm0 2.343V3.478h-.3v2.343h.3z",
    fill: "currentColor",
    mask: "url(#si_clock__a)"
  }));
};

exports.SvgIconClockStroke = SvgIconClockStroke;